import { WHISLIST_DATA } from "../Type/type";

const initialState = {
  isData: false,
  allWishList: []
};

export const whislistDataReducer = (state = initialState, action) => {
  switch (action.type) {
    case WHISLIST_DATA: {
      return {
        ...state,
        allWishList: action.payload,
      };
    }
    default: {
      return state;
    }
  }
};
